import React from "react";
import "../styles/footer.css";

function Footer() {
  return (
    <div>
      <div class="footer-basic">
        <footer>
          <div class="social">
            <a
              href="https://www.instagram.com/yadusuryab"
              target="_blank"
              rel="noreferrer"
            >
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
            <a href="https://wa.me/9495314108" target="_blank" rel="noreferrer">
              <ion-icon name="logo-whatsapp"></ion-icon>
            </a>
            <a
              href="https://www.x.com/yadusuryab"
              target="_blank"
              rel="noreferrer"
            >
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
            <a
              href="https://www.facebook.com/yadusuryab"
              target="_blank"
              rel="noreferrer"
            >
              <ion-icon name="logo-facebook"></ion-icon>
            </a>
          </div>
          <ul class="list-inline">
            <li class="list-inline-item">
              <a href="/">Home</a>
            </li>

            <li class="list-inline-item">
              <a href="/about" target="_blank">
                About
              </a>
            </li>
            <li class="list-inline-item">
              <a href="/terms" target="_blank">
                Terms
              </a>
            </li>
            <li class="list-inline-item">
              <a href="/privacy" target="_blank">
                Privacy
              </a>
            </li>
            <li class="list-inline-item">
              <a href="/contact" target="_blank">
                Contact
              </a>
            </li>
          </ul>
          <p class="copyright">
            &copy; <span className="kspyn">KSPYN</span>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default Footer;